import axios from 'axios';

// Get API URL from environment variable
// In development, this will be empty (uses proxy from package.json)
// In production, set REACT_APP_API_URL to your backend URL (e.g., https://api.yourdomain.com)
const API_URL = process.env.REACT_APP_API_URL || '';

// Configure axios with base URL
const api = axios.create({
  baseURL: API_URL,
});

export default api;

